import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  platform_config = {
    title: 'Messaging Gateway',
  }
  public service_host = 'https://msg.gtwaybe.asi.co.za';
  public service_port = '5420';
  public service_url  = this.service_host;
public dept_contact_conf = [
    {
      "dept_keyword":"msg_gateway",
      "dept_display_name": "Messaging Gateway",
      "email": '',
      "tel_mobile": "",
    }
  ]
public process_config = {
    name: "Messaging Gateway",
    input_always_enabled: false,
  };

  public default_km_summary = "Click here to view FAQ"
  live_chat_max_character = 200;
  public max_visible_rows = 3; //range can be from 1 to 25
  
  public bo_server_error_msg = 'Something went wrong! We are currently unable to process your request'

 public chat_header_config = {
    show_dce_branding: false,
    dce_branding_text: "Powered by Leggero DCE"
  }

  public internet_conn_conf = {
    enable: true,
    net_ping_interval: 5000,
    net_disconnection_buffer: 5000,
    back_online_display_timer: 3000
 }

  public use_local_storage = false;
  public lg_platform = 'DCE';   
  public switch_role_logout_user = true


public date_format = 'dd MMM yyyy HH:mm'
public extension_list = [
  { id: 'pdf', itemName: '.pdf' },
  { id: 'doc', itemName: '.doc' },
  { id: 'docx', itemName: '.docx' },
  { id: 'xlsx', itemName: '.xlsx' },
  { id: 'txt', itemName: '.txt' },
  { id: 'jpg', itemName: '.jpg' },
  { id: 'jpeg', itemName: '.jpeg' },
  { id: 'png', itemName: '.png' }
]

  constructor() { }
}


export const homepage_title='Messaging Gateway'

export const disable_console_log = true;
